(function () {
  const GRID_KEY = "tf:grid-layout";
  const LAYOUTS = ["tf-col-2", "tf-col-3", "tf-col-4", "tf-list-1"];

  function getGrid() {
    return document.querySelector("[data-product-grid]");
  }
  function getSwitchWrap() {
    return document.querySelector("[data-grid-switch]");
  }

  function applyLayout(layout) {
    const grid = getGrid();
    if (!grid) return;

    const finalLayout = LAYOUTS.includes(layout) ? layout : "tf-col-3";

    grid.classList.remove(...LAYOUTS);
    grid.classList.add(finalLayout);

    localStorage.setItem(GRID_KEY, finalLayout);

    const wrap = getSwitchWrap();
    if (!wrap) return;
    wrap.querySelectorAll(".tf-view-layout-switch").forEach((li) => {
      li.classList.toggle("active", li.dataset.valueLayout === finalLayout);
    });
  }

  function init() {
    const wrap = getSwitchWrap();
    if (!wrap) return;
    if (!wrap.__bound) {
      wrap.__bound = true;
      wrap.addEventListener("click", (e) => {
        const btn = e.target.closest(".tf-view-layout-switch");
        if (!btn) return;
        e.preventDefault();
        applyLayout(btn.dataset.valueLayout);
      });
    }

    const saved = localStorage.getItem(GRID_KEY);
    applyLayout(saved || "tf-col-3");
  }

  // document.addEventListener("DOMContentLoaded", init);
  // document.addEventListener("facets:updated", init);
})();

/* ======================================================
 * GRID SWITCH (preferred) + AUTO BREAKPOINT (effective)
 * - Click desktop/mobile đều được
 * - <1200 auto max 3, <768 auto max 2
 * - Active button đổi theo effective
 * - Safe sau AJAX (facets:updated)
 * ====================================================== */
(() => {
  const LAYOUTS = ["tf-col-2", "tf-col-3", "tf-col-4", "tf-list-1"];

  let preferredLayout = null;

  function getGrid() {
    return document.querySelector("[data-product-grid]");
  }

  function getWrap() {
    return document.querySelector("[data-grid-switch]");
  }

  function maxColsByViewport() {
    const w = window.innerWidth;

    if (w < 768) return 2;
    if (w < 1200) return 3;
    return 4;
  }

  function normalizePreferred(v) {
    if (!v) return "tf-col-3";
    v = String(v).trim();
    return LAYOUTS.includes(v) ? v : "tf-col-3";
  }

  function preferredToCols(pref) {
    if (pref === "tf-col-2") return 2;
    if (pref === "tf-col-3") return 3;
    if (pref === "tf-col-4") return 4;
    return null;
  }

  function colsToLayout(cols) {
    if (cols === 2) return "tf-col-2";
    if (cols === 3) return "tf-col-3";
    return "tf-col-4";
  }

  function computeEffective(pref) {
    if (pref === "tf-list-1") return "tf-list-1";

    const prefCols = preferredToCols(pref) || 3;
    const maxCols = maxColsByViewport();

    return colsToLayout(Math.min(prefCols, maxCols));
  }

  function setActiveUI(effective) {
    const wrap = getWrap();
    if (!wrap) return;

    wrap.querySelectorAll(".tf-view-layout-switch").forEach((li) => {
      li.classList.toggle("active", li.dataset.valueLayout === effective);
    });
  }

  function applyLayout(layout) {
    const grid = getGrid();
    if (!grid) return;

    grid.classList.remove(...LAYOUTS);
    grid.classList.add(layout);

    setActiveUI(layout);
  }

  function getDefaultLayout() {
    const wrap = getWrap();
    const grid = getGrid();

    const activeBtn = wrap?.querySelector(".tf-view-layout-switch.active");
    const activeLayout = activeBtn?.dataset.valueLayout;

    if (activeLayout) {
      return normalizePreferred(activeLayout);
    }

    if (grid) {
      const current = LAYOUTS.find((layout) => grid.classList.contains(layout));
      return normalizePreferred(grid.dataset.defaultLayout || current || "tf-col-3");
    }

    return "tf-col-3";
  }

  function applyFromPreferred() {
    const pref = normalizePreferred(preferredLayout || getDefaultLayout());
    const effective = computeEffective(pref);

    applyLayout(effective);
  }

  function onClickSwitch(e) {
    const btn = e.target.closest(".tf-view-layout-switch");
    if (!btn) return;

    e.preventDefault();

    preferredLayout = normalizePreferred(btn.dataset.valueLayout);

    applyFromPreferred();
  }

  function init() {
    const wrap = getWrap();
    const grid = getGrid();
    if (!wrap || !grid) return;

    if (!wrap.__tfBound) {
      wrap.__tfBound = true;
      wrap.addEventListener("click", onClickSwitch);
    }

    applyFromPreferred();
  }

  let rAf = 0;

  function onResize() {
    if (rAf) cancelAnimationFrame(rAf);

    rAf = requestAnimationFrame(() => {
      applyFromPreferred();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    init();
    window.addEventListener("resize", onResize);
  });

  document.addEventListener("facets:updated", () => {
    init();
    applyFromPreferred();
  });

  document.addEventListener("shopify:section:load", () => {
    init();
    applyFromPreferred();
  });
})();

(function () {
  const SIDEBAR_SEL = ".sidebar-filter";
  const OPEN_BTN_SEL = "[data-filter-open]";
  const CLOSE_BTN_SEL = "[data-filter-close]";
  const OVERLAY_SEL = "[data-filter-overlay]";
  const MOBILE_MAX = 999999;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function getSidebar() {
    return document.querySelector(SIDEBAR_SEL);
  }

  function getOverlay() {
    return document.querySelector(OVERLAY_SEL);
  }

  function openDrawer() {
    const sidebar = getSidebar();
    const overlay = getOverlay();
    if (!sidebar || !overlay || !isMobile()) return;

    sidebar.classList.add("is-open");
    overlay.hidden = false;
    document.documentElement.classList.add("tf-filter-open");
  }

  function closeDrawer() {
    const sidebar = getSidebar();
    const overlay = getOverlay();
    if (!sidebar || !overlay) return;

    sidebar.classList.remove("is-open");
    overlay.hidden = true;
    document.documentElement.classList.remove("tf-filter-open");
  }

  function bindOnce() {
    if (document.__tfFilterDrawerBound) return;
    document.__tfFilterDrawerBound = true;

    document.addEventListener("click", (e) => {
      const openBtn = e.target.closest(OPEN_BTN_SEL);
      if (openBtn) {
        e.preventDefault();
        openDrawer();
        return;
      }

      const closeBtn = e.target.closest(CLOSE_BTN_SEL);
      if (closeBtn) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      const overlay = e.target.closest(OVERLAY_SEL);
      if (overlay) {
        e.preventDefault();
        closeDrawer();
        return;
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeDrawer();
    });

    // resize: về desktop thì reset trạng thái
    window.addEventListener("resize", () => {
      if (!isMobile()) closeDrawer();
    });
  }

  document.addEventListener("DOMContentLoaded", bindOnce);

  // Khi facet ajax update xong -> đóng drawer (chỉ mobile)
  // document.addEventListener("facets:updated", () => {
  //   if (isMobile()) closeDrawer();
  // });

  // Nếu bạn chưa phát event facets:updated ở renderFromUrl
  // thì thêm 2 dòng này vào cuối renderFromUrl sau khi replace DOM:
  // document.dispatchEvent(new Event("facets:updated"));
})();